// src/pages/WaitlistForm.js
import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { Container, TextField, Button, Typography, Box, MenuItem } from "@mui/material";

function WaitlistForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    userType: "",
    note: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      await addDoc(collection(db, "waitlist"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        userType: formData.userType,
        note: formData.note,
        createdAt: serverTimestamp(),
      });

      setStatus("✅ Thank you for joining the waitlist!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        userType: "",
        note: ""
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      setStatus("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <Container sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Join the Waitlist
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
        
        {/* Name */}
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          sx={{ mb: 2 }}
        />

        {/* Email */}
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          required
          sx={{ mb: 2 }}
        />

        {/* Phone */}
        <TextField
          label="Phone Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          fullWidth
          required
          sx={{ mb: 2 }}
        />

        {/* User Type */}
        <TextField
          select
          label="I am a"
          name="userType"
          value={formData.userType}
          onChange={handleChange}
          fullWidth
          required
          sx={{ mb: 2 }}
        >
          <MenuItem value="">Select user type</MenuItem>
          <MenuItem value="Retail Investor">Retail Investor</MenuItem>
          <MenuItem value="HNI">HNI / Family Office</MenuItem>
          <MenuItem value="Advisor">Registered Investment Advisor</MenuItem>
          <MenuItem value="Creator">Content Creator / Finfluencer</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        {/* Note */}
        <TextField
          label="Anything you'd like us to know?"
          name="note"
          value={formData.note}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
          sx={{ mb: 2 }}
        />

        {/* Submit */}
        <Button type="submit" variant="contained" color="success" fullWidth>
          Submit
        </Button>
      </Box>

      {status && (
        <Typography variant="body1" sx={{ mt: 3, color: "green" }}>
          {status}
        </Typography>
      )}
    </Container>
  );
}

export default WaitlistForm;